import { useParams } from "react-router-dom";
import IndividualServices from "./services";
import services from "../data/service";

const ServiceWrapper = () => {
  const { slug } = useParams();
  const service = services.find((s) => s.slug === slug);

  if (!service) return <h2>Service Not Found</h2>;
  return (
    <>
      <IndividualServices {...service} />;
    </>
  );
};

export default ServiceWrapper;
